/**
 * URL helpers for the Profile screen's tab strip.
 *
 * The tabs are child routes of `…/profile` (`/platform/profile/onboarding`,
 * `/client/profile/basic-information?id=…`). Switching tabs used to replace the
 * last path segment, which is wrong on the bare index URL `…/profile`: from
 * `/platform/profile` it produced `/platform/onboarding`, an unrouted path that
 * the shell's catch-all redirected in a loop.
 */

const PROFILE_BASE = /^(.*\/profile)(?:\/|$)/;

/** Path of `segment` under the `/profile` base of `pathname`. */
export const profileTabPath = (pathname: string, segment: string): string => {
  const match = pathname.match(PROFILE_BASE);
  const base = match ? match[1] : pathname.replace(/\/[^/]*$/, "");
  return `${base}/${segment}`;
};

/** True on the bare `…/profile` (or `…/profile/`) index URL. */
export const isProfileIndexPath = (pathname: string): boolean =>
  /\/profile\/?$/.test(pathname);
